import { render, staticRenderFns } from "./ComplaintEdit.vue?vue&type=template&id=0387df52"
import script from "./ComplaintEdit.vue?vue&type=script&lang=js"
export * from "./ComplaintEdit.vue?vue&type=script&lang=js"
import style0 from "./ComplaintEdit.vue?vue&type=style&index=0&id=0387df52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports